import { cva, VariantProps } from 'class-variance-authority'
import { forwardRef } from 'react'
import { cn } from '../helpers/classnames'

const hStackVariants = cva(`flex flex-row`, {
  variants: {
    spacing: {
      0: 'gap-0',
      1: 'gap-1',
      2: 'gap-2',
      3: 'gap-3',
      4: 'gap-4',
      5: 'gap-5',
      6: 'gap-6',
      8: 'gap-8',
      10: 'gap-10',
    },
    align: {
      start: 'items-start',
      center: 'items-center',
      end: 'items-end',
      stretch: 'items-stretch',
      baseline: 'items-baseline',
    },
    justify: {
      start: 'justify-start',
      center: 'justify-center',
      end: 'justify-end',
      between: 'justify-between',
      around: 'justify-around',
      evenly: 'justify-evenly',
    },
    wrap: {
      true: 'flex-wrap',
      false: 'flex-nowrap',
    },
  },
  defaultVariants: {
    spacing: 2,
    align: 'center',
    wrap: false,
  },
})

export interface HStackProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof hStackVariants> {}

/**
 * HStack component - Horizontal stack layout
 * Replaces Chakra UI's HStack component
 */
export const HStack = forwardRef<HTMLDivElement, HStackProps>(
  ({ children, spacing, align, justify, wrap, className, ...rest }, ref) => {
    return (
      <div
        ref={ref}
        className={cn(hStackVariants({ spacing, align, justify, wrap, className }))}
        {...rest}
      >
        {children}
      </div>
    )
  }
)

HStack.displayName = 'HStack'